import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

import enTranslation from '../locales/en.json';
import ltTranslation from '../locales/lt.json';
import lvTranslation from '../locales/lv.json';
import plTranslation from '../locales/pl.json';
import ruTranslation from '../locales/ru.json';
import uaTranslation from '../locales/ua.json';
// don't want to use this?
// have a look at the Quick start guide
// for passing in lng and translations on init
const resources = {
 en: { translation: enTranslation },
 lt: { translation: ltTranslation },
 lv: { translation: lvTranslation },
 pl: { translation: plTranslation },
 ru: { translation: ruTranslation },
 ua: { translation: uaTranslation },
};
i18n
 // load translation using http -> see /public/locales (i.e. https://github.com/i18next/react-i18next/tree/master/example/react/public/locales)
 // learn more: https://github.com/i18next/i18next-http-backend
 // want your translations to be loaded from a professional CDN? => https://github.com/locize/react-tutorial#step-2---use-the-locize-cdn
 //   .use(Backend)
 // detect user language
 // learn more: https://github.com/i18next/i18next-browser-languageDetector
 .use(LanguageDetector)
 // pass the i18n instance to react-i18next.
 .use(initReactI18next)
 // init i18next
 // for all options read: https://www.i18next.com/overview/configuration-options
 .init({
  detection: {
   order: ['localStorage'],
   lookupLocalStorage: 'i18nextLng',
  },
  resources,
  supportedLngs: ['en', 'lt', 'lv', 'pl', 'ru', 'ua'],
  fallbackLng: 'lt',
  //   debug: true,

  interpolation: {
   escapeValue: false, // not needed for react as it escapes by default
  },
 });

export default i18n;
